var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { inject as service } from '@ember/service';
export let AccountIssueSeverity = /*#__PURE__*/function (AccountIssueSeverity) {
  AccountIssueSeverity["Critical"] = "critical";
  AccountIssueSeverity["Error"] = "error";
  return AccountIssueSeverity;
}({});
export let AccountIssueSchema = /*#__PURE__*/function (AccountIssueSchema) {
  AccountIssueSchema["GoogleNative"] = "GOOGLE_NATIVE";
  AccountIssueSchema["GoogleFromItem"] = "GOOGLE_FROM_ITEM";
  return AccountIssueSchema;
}({});

// Account issues can be resolved in two different places currently.
export let ResolutionSource = /*#__PURE__*/function (ResolutionSource) {
  ResolutionSource["GoogleMerchantCenter"] = "GOOGLE_MERCHANT_CENTER";
  ResolutionSource["SquareOnline"] = "SQUARE_ONLINE";
  return ResolutionSource;
}({});
export const TITLE_INTL = {
  'Missing value [shipping]': 'onlineChannels.googleShopping.accountLevelIssue.missingShipping',
  'Missing value [tax]': 'onlineChannels.googleShopping.accountLevelIssue.missingTax',
  'Invalid store name': 'onlineChannels.googleShopping.accountLevelIssue.invalidStoreName',
  'Account suspended due to policy violation: Missing return and refund policy': 'onlineChannels.googleShopping.accountLevelIssue.returnPolicy',
  'Website not claimed': 'onlineChannels.googleShopping.accountLevelIssue.verifyAndClaimSite',
  'Missing value for shipping rate [shipping weight]': 'onlineChannels.googleShopping.accountLevelIssue.missingShippingWeight',
  'Account suspended due to policy violation: Misrepresentation': 'onlineChannels.googleShopping.accountLevelIssue.misrepresentation',
  'Account warned for policy violation: Insufficient contact information - there is not enough contact methods on your website, in Merchant Center, or both': 'onlineChannels.googleShopping.accountLevelIssue.contactMethod',
  'The 1:1 logo that you uploaded contains errors or does not conform to our logo requirements': 'onlineChannels.googleShopping.accountLevelIssue.imageRatio',
  'Missing business address': 'onlineChannels.googleShopping.accountLevelIssue.businessAddress',
  'Account warned for policy violation: Website needs improvement': 'onlineChannels.googleShopping.accountLevelIssue.siteImprovement',
  'Your phone number needs to be verified': 'onlineChannels.googleShopping.accountLevelIssue.phoneNumberVerification',
  'Account suspended due to policy violation: Broken checkout experience': 'onlineChannels.googleShopping.accountLevelIssue.brokenCheckout',
  'Account suspended due to policy violation: No products on website': 'onlineChannels.googleShopping.accountLevelIssue.noProducts',
  'Account suspended due to policy violation: Broken landing page': 'onlineChannels.googleShopping.accountLevelIssue.brokenLandingPage',
  'Account suspended due to policy violation: Unsupported Shopping content (Services)': 'onlineChannels.googleShopping.accountLevelIssue.unsupportedContent',
  'Account suspended due to policy violation: checkout incomplete': 'onlineChannels.googleShopping.accountLevelIssue.incompleteCheckout',
  'Account warned for violation of feed specification: Shopping ads policies': 'onlineChannels.googleShopping.accountLevelIssue.crawl',
  'Account suspended due to policy violation: Forbidden pharmaceuticals or products making misleading claims': 'onlineChannels.googleShopping.accountLevelIssue.misleading',
  'Account suspended due to policy violation: Adult-oriented content': 'onlineChannels.googleShopping.accountLevelIssue.adultContent',
  'Account suspended due to policy violation: Missing delivery method': 'onlineChannels.googleShopping.accountLevelIssue.missingDeliveryMethod',
  'Account suspended due to policy violation: Insufficient payment information - missing payment method': 'onlineChannels.googleShopping.accountLevelIssue.missingPaymentMethod',
  'Account suspended due to policy violation: Dangerous products (Tobacco products and related equipment)': 'onlineChannels.googleShopping.accountLevelIssue.dangerousProducts',
  'Account suspended due to policy violation: Dangerous products (Recreational drugs and drug-related equipment)': 'onlineChannels.googleShopping.accountLevelIssue.drugRelated',
  'Account suspended due to policy violation: Local legal requirements and safety standards (live animals)': 'onlineChannels.googleShopping.accountLevelIssue.liveAnimals'
};
let AccountIssue = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('json-or-value'), _dec7 = attr('date'), _dec8 = belongsTo('channels/channel'), _dec9 = attr('string'), _dec10 = computed('severity'), _dec11 = computed('severity'), _dec12 = computed('severity', 'title'), _dec13 = computed('resolutionSource'), _class = class AccountIssue extends Model {
  constructor(...args) {
    super(...args);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "code", _descriptor3, this);
    _initializerDefineProperty(this, "title", _descriptor4, this);
    _initializerDefineProperty(this, "schema", _descriptor5, this);
    _initializerDefineProperty(this, "documentation", _descriptor6, this);
    _initializerDefineProperty(this, "severity", _descriptor7, this);
    _initializerDefineProperty(this, "payload", _descriptor8, this);
    _initializerDefineProperty(this, "lastSeenAt", _descriptor9, this);
    _initializerDefineProperty(this, "channel", _descriptor10, this);
    // Added fields by normalize
    _initializerDefineProperty(this, "resolutionSource", _descriptor11, this);
  }
  get isCritical() {
    return this.severity === AccountIssueSeverity.Critical;
  }
  get isErrorSeverity() {
    return this.severity === AccountIssueSeverity.Error;
  }
  get titleToI18n() {
    const mapping = TITLE_INTL[this.title];
    if (mapping) {
      return this.intl.t(mapping);
    }
    return this.title;
  }
  get isResolvedAtSquareOnline() {
    return this.resolutionSource === ResolutionSource.SquareOnline;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "code", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "schema", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "documentation", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "severity", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "payload", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lastSeenAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "channel", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "resolutionSource", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isCritical", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "isCritical"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isErrorSeverity", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "isErrorSeverity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "titleToI18n", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "titleToI18n"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isResolvedAtSquareOnline", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "isResolvedAtSquareOnline"), _class.prototype), _class);
export { AccountIssue as default };